import React from "react";
import CommandType from "../../CellStepManagement/components/CommandType";

const StepTypeCommand = ({
  id,
  studyId,
  stepType,
  data,
  loading,
  handleClick,
  cells,
  onDone, 
}) => {
  return (
    <CommandType
      data={data}
      loading={loading}
      cells={cells}
      onClick={({ cellId, commandId, closeAfter }) =>
        handleClick(cellId, stepType, studyId, commandId, {closeAfter})
      }
      onDone={onDone}
    />
  );
};


export default StepTypeCommand;
